import { render, staticRenderFns } from "./compliance-limitation.vue?vue&type=template&id=2e198cbf"
import script from "./compliance-limitation.vue?vue&type=script&lang=js"
export * from "./compliance-limitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports